import { render, staticRenderFns } from "./snapshot.vue?vue&type=template&id=5dea0bf0&scoped=true&"
import script from "./snapshot.vue?vue&type=script&setup=true&lang=ts&"
export * from "./snapshot.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./snapshot.vue?vue&type=style&index=0&id=5dea0bf0&prod&lang=scss&"
import style1 from "./snapshot.vue?vue&type=style&index=1&id=5dea0bf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dea0bf0",
  null
  
)

/* custom blocks */
import block0 from "./snapshot.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports